var render = function render(){var _vm=this,_c=_vm._self._c;return _c('component',_vm._b({staticClass:"tamara-link",on:{"click":_vm.handleClick}},'component',_vm.linkProps(_vm.to),false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }